import { z } from 'zod';
import { OnboardingFormFields } from '@Types/types.ts';
import type { Country } from '@Types/country.ts';

interface NationalIdValidationData {
  [OnboardingFormFields.NATIONALITY]?: string;
  [OnboardingFormFields.NATIONAL_ID_NUMBER]?: string;
}

export const validateNationalIdByCountry = (
  data: NationalIdValidationData,
  ctx: z.RefinementCtx,
  countries: Country[]
) => {
  const country = countries.find((c) => c.code === data[OnboardingFormFields.NATIONALITY]);
  if (country?.idValidationRegex && data[OnboardingFormFields.NATIONAL_ID_NUMBER]) {
    if (
      !new RegExp(country.idValidationRegex).test(data[OnboardingFormFields.NATIONAL_ID_NUMBER])
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: country.idValidationDescription,
        path: [OnboardingFormFields.NATIONAL_ID_NUMBER],
      });
    }
  }
};
